import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { contactInfo } from "@/data/content";

const links = [
  { href: "#palvelut", label: "Palvelut" },
  { href: "#nain-toimii", label: "Näin toimii" },
  { href: "#hinnasto", label: "Hinnasto" },
  { href: "#ukk", label: "Kysymykset" },
  { href: "#yhteys", label: "Yhteys" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-50 bg-[#FDFBF7]/90 backdrop-blur-md border-b border-[#E8E2D5]"
    >
      <nav className="max-w-6xl mx-auto px-6 sm:px-8 flex items-center justify-between h-20">
        <a href="#hero" data-testid="logo-link" className="flex items-center gap-3">
          <img src="/digivili-logo.png" alt="Digivili" className="h-12 w-auto" />
          <span className="font-extrabold text-2xl text-[#245037] tracking-tight">Digivili</span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-lg font-semibold text-[#44403C] hover:text-[#245037] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={contactInfo.phoneHref}
            data-testid="nav-phone"
            className="flex items-center gap-2 text-lg font-bold text-[#245037]"
          >
            <Phone strokeWidth={2.5} className="w-5 h-5" />
            {contactInfo.phone}
          </a>
          <a
            href="#yhteys"
            data-testid="nav-cta"
            className="bg-[#245037] text-white hover:bg-[#1A3B28] rounded-xl px-6 py-3 text-lg font-bold transition-transform active:scale-95"
          >
            Ota yhteyttä
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-[#245037]"
          onClick={() => setOpen(!open)}
          aria-label="Valikko"
        >
          {open ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#E8E2D5] bg-[#FDFBF7] px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-lg font-semibold text-[#44403C]"
            >
              {l.label}
            </a>
          ))}
          <a
            href={contactInfo.phoneHref}
            className="flex items-center gap-2 text-lg font-bold text-[#245037]"
          >
            <Phone strokeWidth={2.5} className="w-5 h-5" /> {contactInfo.phone}
          </a>
        </div>
      )}
    </header>
  );
};
